import Component from '../../../scripts/utilities/component';

/**
 * Duplicate - makes a copy of a component and it inserts it in a specified position
 */
class Duplicate extends Component {
    /**
     * componentDidMount - initialisation hook used to initialise the component
     */
    componentDidMount() {
        const componentsToDuplicate = [...this.mount.querySelectorAll('[data-duplicate]')];
        componentsToDuplicate.forEach((component) => {
            const { duplicateTarget } = component.dataset;
            this.duplicate(component, duplicateTarget);
        });
    }

    /**
     * duplicate - duplicates the component and inserts it at the specified position
     * @param {DOM element} component - the component that needs duplicated
     * @param {targetSelector} string - css selector of the container where
                                        the component will get duplicated in
     */
    duplicate(component, targetSelector) {
        if (!targetSelector) {
            console.error(`No duplicate target has been provided for .${component.className}`);
            return;
        }

        const domTarget = this.mount.querySelector(targetSelector);
        if (!domTarget) {
            console.error('The provided duplicate target doesn\'t exist');
            return;
        }

        // make a copy of the component that needs duplicated
        const componentCopy = component.cloneNode(true);

        // if the target isn't the lions tabs (special case), just duplicate the component
        if (targetSelector !== '.content-tabs--lions-den') {
            // append the component to the specified target
            domTarget.appendChild(componentCopy);
        } else {
            // on lions den the duplicated component should be visible only on mobile
            componentCopy.classList.add('hide-on-desktop');

            // the component needs special placement
            const specialTarget = domTarget.querySelector('.content-tabs__panel');
            /*
                if the new target doesn't have enough children to insert the component between them,
                just add it at the end of the target
            */
            if (specialTarget.children.length < 3) {
                specialTarget.appendChild(componentCopy);
            } else {
                // otherwise duplicate the component after the section child
                specialTarget.insertBefore(componentCopy, specialTarget.children[2]);
            }
        }
    }
}

export default Duplicate;



// WEBPACK FOOTER //
// ./components/eng-ms-duplicate/scripts/duplicate.js